import { ProcedureReportTranslations } from '../models/procedure-report-translaction-model';

export const ptBR: ProcedureReportTranslations = {
  title: 'PIT: Gestão Médica / Relatório - Procedimentos',
  tabs: {
    procedures: 'Procedimentos',
    reports: 'Meus Relatórios',
  },
  reports: { layoutName: 'Relatório de Procedimentos' },
  fields: {
    carrier: 'Operadora',
    procedureCode: 'Código Procedimento',
    procedureDescription: 'Descrição do Procedimento',
    tussCode: 'Código TUSS',
    event: 'Evento',
    group: 'Grupo',
    subGroup: 'Subgrupo',
    preventive: 'Preventivo',
    preventiveClassification: 'Classificação Preventivo',
    complement: 'Complemento',
    predictive: 'Preditivo',
    predictiveClassification: 'Classificação Preditivo',
    editedBy: 'Editado por',
    editedAt: 'Editado em',
    status: 'Status',
    additionalTussCode: 'Código TUSS Adicional',
    updateDescription: 'Atualizar Descrição',
    active: 'Ativo',
    ruleLevel: 'Nível',
    ruleValue: 'Valor',
    ruleCriteria: 'Critério',
    ruleReason: 'Motivo',
  },
  filter: {
    expandSearch: 'Expandir Opções de Pesquisa',
    collapseSearch: 'Recolher Opções de Pesquisa',
    clear: 'Limpar Filtros',
    placeholders: { select: 'Selecione' },
    status: {
      classified: 'Classificado',
      unclassified: 'Não classificado',
      pendingApproval: 'Pendente de aprovação',
    },
  },
  actions: {
    export: 'Exportar',
    addNewRegister: 'Adicionar novo registro',
    massActions: {
      label: 'Ação em massa',
      editValues: 'Editar Valores',
      approve: 'Aprovar',
    },
    rowActions: {
      updateHistory: 'Histórico de atualização',
      discardNewRegister: 'Descartar novo registro',
      approve: 'Aprovar',
      justification: 'Editar regra',
      editRule: 'Editar regra',
    },
  },
  table: {
    noData: 'Nenhum item foi encontrado',
    headers: {
      carrier: 'Operadora',
      procedureCode: 'Cód. Procedimento',
      procedureDescription: 'Desc. do Procedimento',
      tussCode: 'Código TUSS',
      event: 'Evento',
      complement: 'Complemento',
      group: 'Grupo',
      subGroup: 'Subgrupo',
      predictive: 'Preditivo',
      predictiveClassification: 'Clas. Preditivo',
    },
  },
  messages: {
    exportError: 'Erro ao exportar relatório de procedimentos',
    loadingText: 'Carregando...',
    noResultText: 'Nenhum resultado encontrado.',
    saveError: 'Erro ao salvar registro do relatório de procedimentos',
    searchError: 'Erro ao buscar o relatório de procedimentos',
    classificationError: 'Erro ao buscar os indicadores de classificação',
    saveSuccess: 'Registro salvo com sucesso.',
    createSuccess: 'Registro criado com sucesso.',
    createManySuccess: '{count} registros criados com sucesso.',
    createPartialSuccess: '{created} de {total} registros criados. Não criados: {rejected}',
    createNoneCreated: 'Nenhum registro foi criado. Não criados: {rejected}',
    rejectedCarrier: '{carrier} - {reason}',
    noPermission: 'Você não tem permissão para salvar este registro.',
    historyError: 'Erro ao buscar o histórico de alterações do relatório de procedimentos',
    approveSuccess: '{approved} procedimento(s) aprovado(s). {ignored} ignorado(s).',
    approveError: 'Erro ao aprovar classificação do procedimento.',
    correctRuleSuccess: 'Regra corrigida com sucesso.',
    correctRuleError: 'Erro ao corrigir regra de classificação.',
    validationFields: {
      carrierId: 'O campo "Operadora" é obrigatório.',
      carrierIds: 'Selecione ao menos uma operadora.',
      procedureCodeId: 'O campo "Código Procedimento" é obrigatório.',
      procedureDescriptionId: 'O campo "Descrição do Procedimento" é obrigatório.',
      tussCodeId: 'O campo "Código TUSS" é obrigatório.',
      eventId: 'O campo "Evento" é obrigatório.',
      complementId: 'O campo "Complemento" é obrigatório.',
      groupId: 'O campo "Grupo" é obrigatório.',
      subGroupId: 'O campo "Subgrupo" é obrigatório.',
      predictiveId: 'O campo "Preditivo" é obrigatório.',
      predictiveClassificationId: 'O campo "Classificação Preditivo" é obrigatório.',
    },
    errors: {
      dimComplementNotFound: 'Complemento não encontrado.',
      descriptionAlreadyExists: 'A descrição já existe.',
      dimEventNotFound: 'Evento não encontrado.',
      dimGroupNotFound: 'Grupo não encontrado.',
      dimPredictiveNotFound: 'Preditivo não encontrado.',
      dimPredictiveClassificationNotFound: 'Classificação Preditivo não encontrada.',
      dimSubgroupNotFound: 'Subgrupo não encontrado.',
      predictiveIdsNotFound: 'Um ou mais IDs de Preditivo não encontrados.',
      groupIdsNotFound: 'Um ou mais IDs de Grupo não encontrados.',
      dimProcedureNotFound: 'Procedimento não encontrado.',
      dimProcedureNotFoundWithId: 'Procedimento não encontrado com o id: {id}',
      procedureAlreadyExists: 'Procedimento com código {code} e operadoraId {id} já existe.',
      procedureCodeNotNull: 'Código do procedimento: não pode ser nulo.',
      carrierIdNotNull: 'Operadora: não pode ser nulo.',
      rejectedProcedureAlreadyExists: 'já existe um registro com este código de procedimento.',
      rejectedCarrierNotFound: 'operadora não encontrada.',
    },
  },
  dashboard: {
    classifiedDescription: 'Procedimentos Classificados',
    nonClassifiedDescription: 'Procedimentos Não Classificados',
    pendingApprovalDescription: 'Pendentes de aprovação',
  },
  levels: {
    event: 'Evento',
    complement: 'Complemento',
    group: 'Grupo',
    subgroup: 'Subgrupo',
    predictive: 'Preditivo',
    predictiveClassification: 'Classificação do Preditivo',
  },
  modals: {
    bulkTitle: 'Editar Valores em Massa',
    editProcedureCode: 'Editar Código Procedimento',
    editProcedureDescription: 'Editar Descrição do Procedimento',
    editTussCode: 'Editar Código TUSS',
    justificationTitle: 'Editar regra',
    editRuleTitle: 'Editar regra',
  },
};
